import { gql } from '@apollo/client'
import type { Album, ListAlbumsResponse, ListAlbumsVariables } from '../types/portfolio'
import { client } from '../utils/apolloClient'


const LIST_COLLECTION = gql`
  query GetCollection($collectionType: String!) {
    listAlbums(
      where: { AND: [{ collectionType: $collectionType }] }
      sort: releaseYear_DESC
    ) {
      data {
        id
        title
        artist
        releaseYear
        genre {
          genre
        }
        description
        image
        links {
          name
          url
        }
        songs {
          id
          songFile
          songTitle
          artist
        }
        pro
        pre
        en
        wr
        mix
        ma
      }
    }
  }
`

function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

function mapGraphAlbumToAlbum(a: Album): Album {
  const slug = `${slugify(a.artist)}-${slugify(a.title)}`
  return {
    id: a.id,
    title: a.title,
    artist: a.artist,
    releaseYear: a.releaseYear,
    genre: a.genre ?? [],
    image: a.image,
    description: a.description ?? null,
    links: a.links,
    songs: a.songs ?? null,
    pro: a.pro,
    pre: a.pre,
    en: a.en,
    wr: a.wr,
    mix: a.mix,
    ma: a.ma,
    slug,
  }
}

export async function fetchAlbums(
  collectionType: 'album' | 'soundtrack' = 'album',
): Promise<Album[]> {
  const { data } = await client.query<ListAlbumsResponse, ListAlbumsVariables>({
    query: LIST_COLLECTION,
    variables: { collectionType },
    fetchPolicy: 'cache-first',
  })

  const albums = data?.listAlbums.data ?? []
  return albums.map(mapGraphAlbumToAlbum)
}

export async function fetchAlbumBySlug(slug: string): Promise<Album | undefined> {
  const albums = await fetchAlbums('album')
  return albums.find((a) => a.slug === slug)
}

